import React, { useState } from 'react';

import {
  GroupSubscriptionRecipient,
  GroupSubscriptionType,
} from '../../../../../utils/backend-api/groupSubscription';
import EditRecipientCard from './EditRecipientCard';
import ShowRecipientCard from './ShowRecipientCard';
import styles from './styles.module.scss';

const SubscriptionOverview = ({
  recipients,
  groupSubscriptionType,
}: {
  recipients: GroupSubscriptionRecipient[];
  groupSubscriptionType: GroupSubscriptionType;
}) => {
  const [editRecipientId, setEditRecipientId] = useState<number | null>();
  return (
    <div className={styles.overViewContainer}>
      {recipients.map((recipient) => (
        <>
          {recipient.recipientId !== editRecipientId ? (
            <ShowRecipientCard recipient={recipient} setEditRecipientId={setEditRecipientId} />
          ) : (
            <EditRecipientCard
              recipient={recipient}
              setEditRecipientId={setEditRecipientId}
              groupSubscriptionType={groupSubscriptionType}
            />
          )}
        </>
      ))}
    </div>
  );
};

export default SubscriptionOverview;
